import React from 'react';
import { useTranslation } from 'react-i18next'; // For language handling


function KSAGEOID17_FAQ() {
  const { t } = useTranslation(); // Hook for translation

  return (
    <div >
    {/* Hero Section */}
    <div className="hero-banner">
      <div className="hero-content" >
        <h1 style={{ color: 'black' }}>{t('FAQ_GEOID17_Title')}</h1>
        
      </div>
      
    </div>
    
    

    {/* Content Section */}
    <div className="hero-banner" style={{ backgroundColor: 'white' }}>
        <div className="hero-content">
          
          <p style={{ textAlign: 'justify' }}><b>{t('FAQ_GEOID17_Q1')}</b></p>
          <p style={{ textAlign: 'justify' }}>{t('FAQ_GEOID17_Q1R1')}</p>
          <p style={{ textAlign: 'justify' }}><b>{t('FAQ_GEOID17_Q2')}</b></p>
          <p style={{ textAlign: 'justify' }}>{t('FAQ_GEOID17_Q2R1')}</p>
          <p style={{ textAlign: 'justify' }}><b>{t('FAQ_GEOID17_Q3')}</b></p>
          <p style={{ textAlign: 'justify' }}>{t('FAQ_GEOID17_Q3R1')}

          <ul>
          <li style={{ textAlign: 'justify' }}>{t('FAQ_GEOID17_Q3R11')}</li>
          <li style={{ textAlign: 'justify' }}>{t('FAQ_GEOID17_Q3R12')}</li>
            </ul></p>
          <p style={{ textAlign: 'justify' }}><b>{t('FAQ_GEOID17_Q4')}</b></p>
          <p style={{ textAlign: 'justify' }}>{t('FAQ_GEOID17_Q4R1')}</p>
          <p style={{ textAlign: 'justify' }}><b>{t('FAQ_GEOID17_Q5')}</b></p>
          <p style={{ textAlign: 'justify' }}>{t('FAQ_GEOID17_Q5_R1')}
          <ul>
          <li style={{ textAlign: 'justify' }}>{t('FAQ_GEOID17_Q5_R11')}</li>
          <li style={{ textAlign: 'justify' }}>{t('FAQ_GEOID17_Q5_R12')}<a  href="https://gds.geoportal.sa/GRF17" target="_blank" rel="noopener noreferrer">
                  {t('Online-GRF-TT')}
                </a> {t('FAQ_GEOID17_Q5_R13')} </li>
          <li style={{ textAlign: 'justify' }}>{t('FAQ_GEOID17_Q5_R14')}<a  href="https://gds.geoportal.sa/VRF" target="_blank" rel="noopener noreferrer">
                  {t('Online-VRF-TT')}
                </a> {t('FAQ_GEOID17_Q5_R13')} </li>
          <li style={{ textAlign: 'justify' }}>{t('FAQ_GEOID17_Q5_R15')} <a
              href={`mailto:${t('email_address')}`}
              target="_blank"
              rel="noopener noreferrer"
             
            > info@geosa.gov.sa</a></li>

        </ul></p>
          <p style={{ textAlign: 'justify' }}><b>{t('FAQ_GEOID17_Q6')}</b></p>
          <p style={{ textAlign: 'justify' }}>{t('FAQ_GEOID17_Q6_R1')}</p>

          <p style={{ textAlign: 'justify' }}><b>{t('FAQ_GEOID17_Q7')}</b></p>
          <p style={{ textAlign: 'justify' }}>{t('FAQ_GEOID17_Q7_R1')}
          <ul>
          <li style={{ textAlign: 'justify' }}>{t('FAQ_GEOID17_Q7_R11')}</li>
          <li style={{ textAlign: 'justify' }}>{t('FAQ_GEOID17_Q7_R12')}</li>

          </ul></p>
          
          <p style={{ textAlign: 'justify' }}><b>{t('FAQ_GEOID17_Q8')}</b></p>
          <p style={{ textAlign: 'justify' }}>{t('FAQ_GEOID17_Q8_R1')}<a  href="https://gds.geoportal.sa/VRF" target="_blank" rel="noopener noreferrer">
                  {t('ksa-geoid-calculator')}
                </a> {t('FAQ_GEOID17_Q8_R2')}  </p>

          <p style={{ textAlign: 'justify' }}><b>{t('FAQ_GEOID17_Q9')}</b></p>
          <p style={{ textAlign: 'justify' }}>{t('FAQ_GEOID17_Q9_R1')}</p>
          <p style={{ textAlign: 'justify' }}><b>{t('FAQ_GEOID17_Q10')}</b></p>
          <p style={{ textAlign: 'justify' }}>{t('FAQ_GEOID17_Q10_R1')}</p>
          <p style={{ textAlign: 'justify' }}><b>{t('FAQ_GEOID17_Q11')}</b></p>
          <p style={{ textAlign: 'justify' }}>{t('FAQ_GEOID17_Q11_R1')}</p>
          
          <table className='table-container'>
        
        <tbody>
          <tr>
          <td ><b>#</b></td>
          <td ><b>{t('FAQ_GEOID17_Q11_R1_tab_head1')}</b></td>
          <td ><b>{t('FAQ_GEOID17_Q11_R1_tab_head2')}</b></td>
          <td ><b>{t('FAQ_GEOID17_Q11_R1_tab_head3')}</b></td>
          <td ><b>{t('FAQ_GEOID17_Q11_R1_tab_head4')}</b></td>
          </tr>
          <tr>
            <td >1</td>
            <td >{t('FAQ_GEOID17_Q11_R1_tab_line11')}</td>
            <td >{t('FAQ_GEOID17_Q11_R1_tab_line12')}</td>
            <td >{t('FAQ_GEOID17_Q11_R1_tab_line13')}</td>
            <td >{t('FAQ_GEOID17_Q11_R1_tab_line14')}</td>
          </tr>
          <tr>
            <td >2</td>
            <td >{t('FAQ_GEOID17_Q11_R1_tab_line21')}</td>
            <td >{t('FAQ_GEOID17_Q11_R1_tab_line221')}<br/>{t('FAQ_GEOID17_Q11_R1_tab_line222')}</td>
            <td >{t('FAQ_GEOID17_Q11_R1_tab_line231')}<br/>{t('FAQ_GEOID17_Q11_R1_tab_line232')}</td>
            <td >{t('FAQ_GEOID17_Q11_R1_tab_line24')}</td>
          </tr>
          <tr>
            <td >3</td>
            <td >{t('FAQ_GEOID17_Q11_R1_tab_line31')}</td>
            <td >{t('FAQ_GEOID17_Q11_R1_tab_line32')}</td>
            <td >{t('FAQ_GEOID17_Q11_R1_tab_line33')}</td>
            <td >{t('FAQ_GEOID17_Q11_R1_tab_line34')}</td>
          </tr>
          <tr>
            <td >4</td>
            <td >{t('FAQ_GEOID17_Q11_R1_tab_line41')}</td>
            <td >{t('FAQ_GEOID17_Q11_R1_tab_line42')}</td>
            <td >{t('FAQ_GEOID17_Q11_R1_tab_line43')}</td>
            <td >{t('FAQ_GEOID17_Q11_R1_tab_line44')}</td>
          </tr>
          <tr>
            <td >5</td>
            <td >{t('FAQ_GEOID17_Q11_R1_tab_line51')}</td>
            <td >{t('FAQ_GEOID17_Q11_R1_tab_line52')}</td>
            <td >{t('FAQ_GEOID17_Q11_R1_tab_line53')}</td>
            <td >{t('FAQ_GEOID17_Q11_R1_tab_line54')}</td>
          </tr>
          
          
          
        </tbody>
      </table>
      
        </div>
      </div>
      <div className="cards-space" style={{height:"40px"}}></div>
      
      
 
    
    </div>
);
}

export default KSAGEOID17_FAQ;
